<template>
  <div>
    <vl-mobile-filter-template label="Deadline(s) actie" :open="open" :toggleable="toggleable"
                               @clear-filter="clearDeadlineFilter">
      <div class="xl:hidden">
        <div class="mt-2 flex justify-between">
          <div class="text-14p">Van</div>
          <div>
            <vl-date-picker-large v-model="FromDate"/>
          </div>
        </div>
        <div class="mt-2 flex justify-between">
          <div class="text-14p">t.e.m.</div>
          <div>
            <vl-date-picker-large v-model="ToDate"/>
          </div>
        </div>
      </div>
      <div class="hidden xl:grid grid-cols-1fr-min-1fr-min gap-8p">
        <div>Van</div>
        <vl-date-picker-small v-model="FromDate"/>
        <div>t.e.m</div>
        <vl-date-picker-small v-model="ToDate"/>
      </div>
      <div class="mt-2">
        <vl-checkbox label="Toon alle verstreken deadlines" v-model="Passed"/>
      </div>
    </vl-mobile-filter-template>
  </div>
</template>

<script>
import VlMobileFilterTemplate from "@/components/Elements/Filters/VlFilterTemplate";
import VlDatePickerLarge from '@/components/Elements/Form/Elements/VlDatePickerLarge'
import VlCheckbox from "@/components/Elements/Form/Elements/VlCheckbox";
import VlDatePickerSmall from "@/components/Elements/Form/Elements/VlDatePickerSmall";

export default {
  name: "VlDeadlineFilter",
  components: {
    VlMobileFilterTemplate,
    VlDatePickerLarge,
    VlDatePickerSmall,
    VlCheckbox
  },
  props: {
    open: {
      type: Boolean,
      required: false,
      default: true
    },
    toggleable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    FromDate: {
      get() {
        return this.$store.state.DossierModule.FilterModule.filters.deadline.from
      },
      set(value) {
        this.$store.dispatch('DossierModule/FilterModule/updateFilter', {
          filter: 'deadline.from',
          data: value
        })
      }
    },
    ToDate: {
      get() {
        return this.$store.state.DossierModule.FilterModule.filters.deadline.to
      },
      set(value) {
        this.$store.dispatch('DossierModule/FilterModule/updateFilter', {
          filter: 'deadline.to',
          data: value
        })
      }
    },
    Passed: {
      get() {
        return this.$store.state.DossierModule.FilterModule.filters.deadline_passed
      },
      set(value) {
        this.$store.dispatch('DossierModule/FilterModule/updateFilter', {
          filter: 'deadline_passed',
          data: value
        })
      }
    }
  },
  methods: {
    clearDeadlineFilter() {
      this.$store.dispatch('DossierModule/FilterModule/clearDeadlineFilter')
      this.$store.dispatch('DossierModule/FilterModule/clearDeadlinePassedFilter')
    }
  }
}
</script>

<style scoped>

</style>
